export default "Female_27_Cuba_1.png\nFemale_27_Cuba_2.png\nFemale_27_Cuba_3.png\nFemale_27_Cuba_4.png\nFemale_SouthCentralAmerica.txt\n";